import ClaimListing from 'app/shared/model/ClaimListing';

const ClaimPropertyResponse = ({
    totalListingCount = 0,
    listings = [],
} = {}) => ({
    totalListingCount: Number(totalListingCount),
    listings: listings.map(ClaimListing),
});

export default ClaimPropertyResponse;
